/**
 * Batches scroll-into-view into one animation frame to reduce layout jitter when
 * multiple sections expand or Collapse fires layout work.
 */
let rafId: number | null = null
let pendingEl: Element | null = null

export function scrollOrderDisclosureSectionIntoView(el: Element | null | undefined): void {
  pendingEl = el ?? null
  if (rafId != null) {
    cancelAnimationFrame(rafId)
  }
  rafId = requestAnimationFrame(() => {
    rafId = null
    const target = pendingEl
    pendingEl = null
    target?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" })
  })
}
